export default "__VITE_ASSET__xlCQfVdL__"